'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["type", "onClose"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import H4 from 'UIComponents/elements/headings/H4';
import PersonalizeBrowser from './PersonalizeBrowser';
import { KeyTypes, PopoverType } from '../../constants/popover';
import { i18nKey } from '../../utils/properties';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function PersonalizePopoverBody(props) {
  const {
      type,
      onClose
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const handleKeyDown = event => {
    if (event.key === KeyTypes.ESCAPE) {
      onClose();
    }
  };
  return /*#__PURE__*/_jsxs("div", {
    className: "medium-popover-body p-top-5",
    tabIndex: "-1",
    onKeyDown: handleKeyDown,
    children: [/*#__PURE__*/_jsx(H4, {
      className: "p-x-5 m-bottom-2",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: i18nKey(`title.${type}`)
      })
    }), /*#__PURE__*/_jsx(PersonalizeBrowser, Object.assign({
      isInsert: type === PopoverType.INSERT,
      onClose: onClose
    }, rest))]
  });
}